import {CamToCamParams} from "../application/interfaces";
import {Application} from "../application/application";
import {CamToCamBase} from "./cam2cam-base";
import {CamToCamWebRTC} from "./cam2cam-webrtc";
import {CamToCamWebRTCNg} from "./cam2cam-webrtc-ng";

export enum Status
{
	streamingMini,
	idle,
	loading,
	approve,
	noCam,
	preconfig,
	config,
	camApproved,
	prepareStream,
	streaming,
	leaving,
}

function isWebRtcSupported(): boolean
{
	return !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia && RTCPeerConnection);
}

export function initCam2Cam($root: JQuery,
                            params: CamToCamParams,
                            app: Application) : CamToCamBase
{
	return isWebRtcSupported()
		? new CamToCamWebRTCNg($root, params, app)
		: null;
}
